import { formatTestId } from "@nimble/ts-formatters/format-test-ids";
import Link from "next/link";

import { schoolStatsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";

type SchoolDetailDistanceFromLocationProps = {
  schoolId: string;
  distanceFromLocation: number;
  directionsUrl: string;
};

export default function SchoolDetailDistanceFromLocation({
  schoolId,
  distanceFromLocation,
  directionsUrl,
}: SchoolDetailDistanceFromLocationProps) {
  if (distanceFromLocation <= 0) {
    return null;
  }

  const content = `(${distanceFromLocation.toFixed(2)} mi)`;

  return (
    <Link
      href={directionsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs sm:text-sm font-medium text-ink-subtle hover:text-ink-emphasis cursor-pointer"
      data-testid={`${schoolStatsTestIds.SCHOOL_DISTANCE_FROM_LOCATION}-${formatTestId(
        schoolId,
      )}`}
    >
      {content}
    </Link>
  );
}
